<script>
import Layout from '@layouts/main';
import LocationForm from '@views/locations/form';

export default {
  components: {
    Layout,
    LocationForm,
  },
  props: {
    areas: {
      required: true,
      type: Array,
      default: null,
    }
  },
  page() {
    return {
      title: this.$t('titles.create_location'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.locations'),
          to: { name: 'locations.index' },
        },
        {
          text: this.$t('titles.create_location'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'locations.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_location')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <LocationForm :areas="areas" @submitted="create"/>
    </b-card>
  </Layout>
</template>
